import React from 'react';
import { useSelector } from 'react-redux';
import { SiteSettingsProps } from '../../../ECDApp/global/models/epi-model';
import { TcsmStates } from '../../root/tcsm-model';
import { DividerSection } from './layout/divider-section';
import { MainContent } from './layout/main-content-container';
import { PageContainer } from './layout/page-container';
import { WysiwygWithReactLink } from './wysiwyg-with-react-link';


export function ReactErrorFallbackContent() {

    const settings = useSelector<TcsmStates, SiteSettingsProps>(state=> state?.epiProps?.siteSettingsState?.siteSettings);


    return (

        <PageContainer>
            <MainContent>
                <DividerSection removeDivider>
                    <div className="news-message">
                        <WysiwygWithReactLink content={settings?.tcsmFatalErrorMessage} />
                    </div>
                </DividerSection>

            </MainContent>


        </PageContainer>
    );
}